import z from 'zod'

export const millsheetSortConfigSchema = z.object({
  // 「メーカー」「規格」「形状」の並び替え順をカスタマイズ設定できる
  manufacturerName: z.string().array().nullish(),
  steelType: z.string().array().nullish(),
  sectionType: z.string().array().nullish(),
})

export type MillsheetSortConfig = z.infer<typeof millsheetSortConfigSchema>

export function sortStringsByConfig(values: string[], configOrder: string[] | null | undefined): string[] {
  if (!configOrder || configOrder.length === 0) {
    return [...values].sort((a, b) => a.localeCompare(b, 'ja', { numeric: true, sensitivity: 'base' }))
  }
  return [...values].sort((a, b) => {
    const aIdx = configOrder.indexOf(a)
    const bIdx = configOrder.indexOf(b)
    const aEff = aIdx === -1 ? configOrder.length : aIdx
    const bEff = bIdx === -1 ? configOrder.length : bIdx
    if (aEff !== bEff) {
      return aEff - bEff
    }
    // 両方とも未設定の場合は localeCompare フォールバック
    return a.localeCompare(b, 'ja', { numeric: true, sensitivity: 'base' })
  })
}

type Value = string | null | number
export function sortMillsheetItems<Item extends Record<string, Value>>(
  items: Item[],
  sortConfig: MillsheetSortConfig,
  sortKeys: string[],
): Item[] {
  if (sortKeys.length === 0) {
    return items
  }
  // 汎用的に使えるようにするため、Record型のItemを、keysでソートする
  return [...items].sort((a, b) => {
    for (const sortKey of sortKeys) {
      const aValue = a[sortKey] ?? ''
      const bValue = b[sortKey] ?? ''
      if (aValue !== bValue) {
        return compareMillsheetItemValueByConfig(aValue, bValue, sortConfig, sortKey)
      }
    }
    return 0
  })
}

export function compareMillsheetItemValueByConfig(
  aValue: Value,
  bValue: Value,
  sortConfig: MillsheetSortConfig,
  sortKey: string,
) {
  const sortConfigItem = sortConfig[sortKey as keyof MillsheetSortConfig] ?? []
  if (sortConfigItem.length > 0 && typeof aValue === 'string' && typeof bValue === 'string') {
    const aFoundIndex = sortConfigItem.indexOf(aValue)
    const bFoundIndex = sortConfigItem.indexOf(bValue)
    // 含まれていない値は、最後扱いにする
    const aIndex = aFoundIndex === -1 ? sortConfigItem.length : aFoundIndex
    const bIndex = bFoundIndex === -1 ? sortConfigItem.length : bFoundIndex
    return aIndex - bIndex
  }

  if (typeof aValue === 'number' && typeof bValue === 'number') {
    return aValue - bValue
  }

  if (aValue === null && bValue === null) {
    return 0
  }
  if (aValue === null) {
    return 1
  }
  if (bValue === null) {
    return -1
  }

  if (typeof aValue === 'string' && typeof bValue === 'string') {
    return aValue.localeCompare(bValue, 'ja', { numeric: true, sensitivity: 'base' })
  }

  return 0
}
